import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './TitleWithButton.module.scss';

const TitleWithButton = ({ variant: Variant, title, className, children, titleWrapper: TitleWrapper }) => (
  <Variant className={cn(styles.header, className)}>
    <TitleWrapper className={styles.title}>{title}</TitleWrapper>
    {children}
  </Variant>
);

TitleWithButton.propTypes = {
  variant: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  titleWrapper: PropTypes.string,
};

TitleWithButton.defaultProps = {
  variant: 'h2',
  className: '',
  title: null,
  titleWrapper: 'span',
};

export default TitleWithButton;
